// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__lHB7z","icon_preview":"style_icon_preview__ka2su","icon_button":"style_icon_button__YL8Ys"};